import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

export const EmployeeImportDataApiService = async (
  request: number
): Promise<boolean> => {
  const uri = `/employeeimportfiles/${request}/import/`;
  const { data } = await axios.post(uri);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useEmployeeImportDataApiService = () =>
  useMutation<boolean, AxiosError, number>(
    "EmployeeImportDataApiService",
    EmployeeImportDataApiService
  );

export default useEmployeeImportDataApiService;
